// Simple quantity controls on listing cards, layered on top of core Add to Cart logic.
// Rules:
// - When quantity is 0: show default Add to Cart button.
// - When quantity > 0: show +/- spinner and keep the cart-indicator; hide the Go to Cart button.
//
// Page-agnostic by design (same reasoning as product_variant_swatches.js): this
// used to hard-gate on #product-listing, which only exists on /all-products and
// item-group pages. Any card rendered elsewhere - an RFHQ Item Grid/Carousel on
// the homepage, a search result, anywhere webshop.ProductGrid's markup shows up -
// never got a #product-listing ancestor, so the qty spinner never appeared there
// even though core's Add to Cart click went through fine. Scoping to
// document/document.body instead lets it work on any .item-card/.list-row,
// wherever it lives.

frappe.ready(function () {
  function getCurrentQty(card, itemCode) {
    var input = card.querySelector('.listing-qty-wrapper[data-item-code="' + itemCode + '"] .cart-qty');
    if (input) {
      var value = parseInt(input.value || '0', 10);
      return isNaN(value) ? 0 : Math.max(0, value);
    }

    var indicator = card.querySelector('.cart-indicator[data-item-code="' + itemCode + '"]');
    if (indicator && !indicator.classList.contains('hidden')) {
      var indicatorValue = parseInt((indicator.textContent || '').trim(), 10);
      if (!isNaN(indicatorValue)) {
        return Math.max(0, indicatorValue);
      }
      return 1;
    }

    var goToCart = card.querySelector('.go-to-cart-grid[data-item-code="' + itemCode + '"]');
    if (goToCart && !goToCart.classList.contains('hidden')) {
      return 1;
    }

    return 0;
  }

  function renderQtyControls(card, itemCode, initialQty) {
    if (!card || !itemCode) return;
    // raftor_websitehq draws this card and renders its own qty stepper from
    // cart state; adding a second one here would show two.
    if (window.webhqOwnedSurface && window.webhqOwnedSurface(card)) return;

    // Avoid duplicating controls
    var existing = card.querySelector('.listing-qty-wrapper[data-item-code="' + itemCode + '"]');
    if (existing) {
      existing.classList.remove('hidden');
      var inputExisting = existing.querySelector('.cart-qty');
      if (inputExisting && initialQty != null) {
        inputExisting.value = String(initialQty);
      }
      return;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'listing-qty-wrapper mt-1';
    wrapper.setAttribute('data-item-code', itemCode);

    wrapper.innerHTML = [
      '<div class="d-flex align-items-center listing-qty-inner">',
      '  <div class="input-group number-spinner">',
      '    <span class="input-group-prepend d-sm-inline-block">',
      '      <button class="btn cart-btn" data-dir="dwn">&minus;</button>',
      '    </span>',
      '    <input class="form-control text-center cart-qty"',
      '           value="' + (initialQty != null ? initialQty : 1) + '"',
      '           data-item-code="' + frappe.utils.escape_html(itemCode) + '"',
      '           style="max-width: 70px;">',
      '    <span class="input-group-append d-sm-inline-block">',
      '      <button class="btn cart-btn" data-dir="up">+</button>',
      '    </span>',
      '  </div>',
      '  <a href="/cart" class="listing-go-to-cart ml-2" aria-label="Go to cart">',
      '    <svg class="icon sm" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">',
      '      <path d="M6 16a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm8 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM3 3h1.2l.9 6h7.8l1.1-4.4A.5.5 0 0 0 13.5 4h-8" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>',
      '    </svg>',
      '  </a>',
      '</div>'
    ].join('');

    // Append at the end of card-body, not into .cart-action-container: on a
    // variant template, product_variant_swatches.js appends its own Size/
    // price block (.variant-swatches) AND its "Add to Cart" button directly
    // to card-body, AFTER raftor_websitehq's (now-empty) .cart-action-
    // container. Targeting that container here would insert the stepper
    // BEFORE that content instead of replacing the button in its actual
    // visual position — landing it mid-card instead of at the bottom, same
    // spot product_variant_swatches.js's own button already correctly used.
    var cardBodyEl = card.querySelector('.card-body');
    if (cardBodyEl) {
      cardBodyEl.appendChild(wrapper);
    } else {
      card.appendChild(wrapper);
    }

    // Hide the Add to Cart button for this item while quantity > 0
    var addBtn = card.querySelector('.btn-add-to-cart-list[data-item-code="' + itemCode + '"]');
    if (addBtn) {
      addBtn.classList.add('hidden');
    }

    var wrapperAfterCreate = card.querySelector('.listing-qty-wrapper[data-item-code="' + itemCode + '"]');
    var inputAfterCreate = wrapperAfterCreate ? wrapperAfterCreate.querySelector('.cart-qty') : null;
    if (inputAfterCreate) {
      inputAfterCreate.dataset.syncedQty = String(initialQty != null ? initialQty : 1);
      inputAfterCreate.dataset.pendingUpdate = '0';
    }
  }

  function updateQty(card, itemCode, newQty) {
    if (newQty < 0) newQty = 0;

    var shoppingCart =
      window.shopping_cart ||
      (window.webshop && webshop.webshop && webshop.webshop.shopping_cart);
    if (!shoppingCart || typeof shoppingCart.update_cart !== "function") {
      return;
    }

    var wrapperBeforeUpdate = card.querySelector('.listing-qty-wrapper[data-item-code="' + itemCode + '"]');
    var inputBeforeUpdate = wrapperBeforeUpdate ? wrapperBeforeUpdate.querySelector('.cart-qty') : null;
    if (inputBeforeUpdate) {
      inputBeforeUpdate.dataset.pendingUpdate = '1';
    }

    shoppingCart.update_cart({
      item_code: itemCode,
      qty: newQty,
      with_items: 0,
      callback: function (r) {
        if (r && r.exc) {
          if (inputBeforeUpdate) inputBeforeUpdate.dataset.pendingUpdate = '0';
          return; // do not change UI on backend error
        }

        var wrapper = card.querySelector('.listing-qty-wrapper[data-item-code="' + itemCode + '"]');
        if (wrapper) {
          var input = wrapper.querySelector('.cart-qty');
          if (input) {
            input.value = String(newQty);
            input.dataset.syncedQty = String(newQty);
            input.dataset.pendingUpdate = '0';
          }
        }

        var addBtnAfter = card.querySelector('.btn-add-to-cart-list[data-item-code="' + itemCode + '"]');
        if (addBtnAfter) {
          addBtnAfter.classList.toggle('hidden', newQty > 0);
        }

        var wrapperAfter = card.querySelector('.listing-qty-wrapper[data-item-code="' + itemCode + '"]');
        if (wrapperAfter) {
          wrapperAfter.classList.toggle('hidden', newQty <= 0);
        }

        if (window.jQuery && typeof window.jQuery === 'function') {
          window.jQuery(document).trigger('cart-updated', [{ item_code: itemCode, qty: newQty }]);
        }
        refreshListingFromServerCart();
      },
    });
  }

  function syncExistingInCartCards(root) {
    var scope = root || document;

    // When core marks items as in_cart (via cart-indicator), reflect that with qty controls.
    Array.prototype.forEach.call(
      scope.querySelectorAll('.cart-indicator[data-item-code]'),
      function (indicator) {
        if (indicator.classList.contains('hidden')) return;
        var itemCode = indicator.getAttribute('data-item-code');
        if (!itemCode) return;
        var card = indicator.closest('.item-card, .card');
        if (!card) return;
        renderQtyControls(card, itemCode, getCurrentQty(card, itemCode) || 1);
      }
    );

    // Additionally, handle cases where core only rendered a visible go-to-cart-grid
    // button (item.in_cart true) without a cart-indicator element.
    Array.prototype.forEach.call(
      scope.querySelectorAll('.go-to-cart-grid[data-item-code]'),
      function (btn) {
        if (btn.classList.contains('hidden')) return;
        var itemCode = btn.getAttribute('data-item-code');
        if (!itemCode) return;
        var card = btn.closest('.item-card, .card');
        if (!card) return;
        renderQtyControls(card, itemCode, getCurrentQty(card, itemCode) || 1);
      }
    );

    if (typeof window.applyMobileLayoutIfNeeded === 'function') {
      window.applyMobileLayoutIfNeeded();
    }
  }

  var lastCartSnapshotDoc = null;

  // Initial pass after DOM ready (in case grid HTML is already present)
  syncExistingInCartCards();

  function applyCartSnapshotToListing(cartDoc) {
    if (!cartDoc || !Array.isArray(cartDoc.items)) return;

    var qtyByItemCode = {};
    cartDoc.items.forEach(function (row) {
      if (!row || !row.item_code) return;
      qtyByItemCode[row.item_code] = parseFloat(row.qty || 0) || 0;
    });

    Array.prototype.forEach.call(
      document.querySelectorAll('.btn-add-to-cart-list[data-item-code], .listing-qty-wrapper[data-item-code], .cart-indicator[data-item-code]'),
      function (el) {
        var itemCode = el.getAttribute('data-item-code');
        if (!itemCode) return;

        var card = el.closest('.item-card, .card');
        if (!card) return;
        // Every other entry point in this file (renderQtyControls, the click/
        // change delegates) already skips raftor_websitehq-owned cards via
        // this same check -- this one was missed. webhqDom.onAdded (below)
        // replays the last cached cart snapshot for ANY newly added node
        // anywhere on the page, including the fresh stepper RfhqProductGrid's
        // patchSlot just rendered on an Add to Cart click -- with no guard
        // here, that replay used a snapshot cached from BEFORE the click
        // (qty still 0) and hid the just-rendered stepper it doesn't own or
        // understand, seconds after it correctly appeared.
        if (window.webhqOwnedSurface && window.webhqOwnedSurface(card)) return;

        var qty = qtyByItemCode[itemCode] || 0;
        if (qty > 0) {
          var wrapperExisting = card.querySelector('.listing-qty-wrapper[data-item-code="' + itemCode + '"]');
          if (wrapperExisting) {
            wrapperExisting.classList.remove('hidden');
            var inputExisting = wrapperExisting.querySelector('.cart-qty');
            if (inputExisting) {
              inputExisting.value = String(qty);
              inputExisting.dataset.syncedQty = String(qty);
              inputExisting.dataset.pendingUpdate = '0';
            }
            var addBtnExisting = card.querySelector('.btn-add-to-cart-list[data-item-code="' + itemCode + '"]');
            if (addBtnExisting) addBtnExisting.classList.add('hidden');
          } else {
            renderQtyControls(card, itemCode, qty);
          }
        } else {
          var wrapper = card.querySelector('.listing-qty-wrapper[data-item-code="' + itemCode + '"]');
          if (wrapper) wrapper.classList.add('hidden');
          var addBtn = card.querySelector('.btn-add-to-cart-list[data-item-code="' + itemCode + '"]');
          if (addBtn) addBtn.classList.remove('hidden');
          var indicator = card.querySelector('.cart-indicator[data-item-code="' + itemCode + '"]');
          if (indicator) indicator.classList.add('hidden');
          var goToCart = card.querySelector('.go-to-cart-grid[data-item-code="' + itemCode + '"]');
          if (goToCart) goToCart.classList.add('hidden');
        }
      }
    );
  }

  var cartRefreshInFlight = false;
  var cartRefreshQueued = false;
  var cartRefreshTimer = null;

  function refreshListingFromServerCart() {
    // Page-agnostic (see this file's own header comment) means "don't
    // hard-gate on #product-listing", not "always fire regardless of
    // whether there's a single relevant card anywhere" -- this used to run
    // unconditionally on frappe.ready, plus again on every pageshow/
    // visibilitychange, on EVERY page site-wide (bundled into webhq.bundle.js
    // loaded everywhere), including pages with zero listing cards at all --
    // /cart chief among them. Found live via a full network trace of a
    // shop->cart navigation: this call (get_cart_items_snapshot) and
    // product_variant_swatches.js's own identical unconditional call were
    // firing back-to-back on every single /cart load AND after every qty
    // tap (via the 'cart-updated' event), each one a real round-trip
    // competing with the actual cart request on the dev server's
    // single-threaded queue -- a meaningful chunk of what read as "cart is
    // fucking slow" turned out to be two entirely unrelated scripts syncing
    // a UI that isn't even on the page.
    if (!document.querySelector('.btn-add-to-cart-list[data-item-code], .listing-qty-wrapper[data-item-code], .cart-indicator[data-item-code], .go-to-cart-grid[data-item-code]')) {
      return;
    }

    if (cartRefreshTimer) {
      clearTimeout(cartRefreshTimer);
    }

    cartRefreshTimer = setTimeout(function () {
      if (cartRefreshInFlight) {
        cartRefreshQueued = true;
        return;
      }
      cartRefreshInFlight = true;

      var finalized = false;

      function finalizeRefresh() {
        if (finalized) return;
        finalized = true;
        cartRefreshInFlight = false;
        if (cartRefreshQueued) {
          cartRefreshQueued = false;
          refreshListingFromServerCart();
        }
      }

      function fallbackToFullCartAndFinalize() {
        var req2 = frappe.call({
          type: 'GET',
          method: 'webshop.webshop.shopping_cart.cart.get_cart_quotation',
          callback: function (r2) {
            if (r2 && r2.message && r2.message.doc) {
              lastCartSnapshotDoc = r2.message.doc;
              applyCartSnapshotToListing(lastCartSnapshotDoc);
            }
          }
        });

        if (req2 && typeof req2.always === 'function') {
          req2.always(finalizeRefresh);
        } else {
          finalizeRefresh();
        }
      }

      var req = frappe.call({
        type: 'GET',
        method: 'raftor_webhq.checkout.simple_checkout.get_cart_items_snapshot',
        callback: function (r) {
          if (r && r.message && r.message.items) {
            lastCartSnapshotDoc = { items: r.message.items };
            applyCartSnapshotToListing(lastCartSnapshotDoc);
            finalizeRefresh();
            return;
          }

          fallbackToFullCartAndFinalize();
        },
        error: function () {
          fallbackToFullCartAndFinalize();
        }
      });

      if (!req || typeof req.always !== 'function') {
        finalizeRefresh();
      }
    }, 150);
  }

  if (window.jQuery && typeof window.jQuery === 'function') {
    window.jQuery(document).on('cart-updated', function () {
      refreshListingFromServerCart();
    });
  }

  // Watch for product cards being added later (grid rendered dynamically)
  window.webhqDom.onAdded(function (roots) {
    roots.forEach(function (node) {
      if (!(node instanceof HTMLElement)) return;
      syncExistingInCartCards(node);

      if (lastCartSnapshotDoc) {
        applyCartSnapshotToListing(lastCartSnapshotDoc);
      }

      // Force mobile layout when products are added
      if (typeof window.applyMobileLayoutIfNeeded === 'function') {
        window.applyMobileLayoutIfNeeded();
      }
    });
  });

  refreshListingFromServerCart();

  window.addEventListener('pageshow', function () {
    refreshListingFromServerCart();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      refreshListingFromServerCart();
    }
  });

  // Force mobile layout on initial load and when viewport changes
  window.applyMobileLayoutIfNeeded = function() {
    if (window.innerWidth <= 767) {
      // Target the actual structure: .list-row inside #product-listing
      const listRows = document.querySelectorAll('#product-listing .list-row');
      listRows.forEach(function(row) {
        row.style.display = 'flex';
        row.style.flexWrap = 'wrap';
        row.style.gap = '0.05rem';
        
        const cols = row.querySelectorAll('[class*="col-"]');
        cols.forEach(function(col) {
          col.style.flex = '0 0 50%';
          col.style.maxWidth = '50%';
          col.style.paddingLeft = '0.1rem';
          col.style.paddingRight = '0.1rem';
        });
      });
    }
  }

  // Apply on load
  if (typeof window.applyMobileLayoutIfNeeded === 'function') {
    window.applyMobileLayoutIfNeeded();
  }
  
  // Apply on resize
  window.addEventListener('resize', window.applyMobileLayoutIfNeeded);
  // After the core Add to Cart handler runs, convert the button into qty controls
  document.addEventListener('click', function (event) {
    if (window.webhqOwnedSurface && window.webhqOwnedSurface(event.target)) return;
    var btn = event.target.closest('.btn-add-to-cart-list[data-item-code]');
    if (!btn) return;

    // Ignore Go to Cart buttons; they are hidden via CSS and/or handled by core
    if (btn.classList.contains('go-to-cart-grid')) {
      return;
    }

    // Let core handler manage guests and backend update
    if (frappe.session && frappe.session.user === 'Guest') {
      return;
    }

    var itemCode = btn.getAttribute('data-item-code');
    if (!itemCode) return;

    var card = btn.closest('.item-card, .card');
    if (!card) return;

    // Render our controls on the next tick so we don't create a visible gap.
    // renderQtyControls() will hide the Add to Cart button as needed.
    setTimeout(function () {
      renderQtyControls(card, itemCode, 1);
    }, 0);

    setTimeout(function () {
      refreshListingFromServerCart();
    }, 200);
  });

  // Delegate +/- clicks for listing qty controls
  document.addEventListener('click', function (event) {
    if (window.webhqOwnedSurface && window.webhqOwnedSurface(event.target)) return;
    var upDownBtn = event.target.closest('.listing-qty-wrapper .number-spinner button');
    if (!upDownBtn) return;

    var wrapper = upDownBtn.closest('.listing-qty-wrapper');
    if (!wrapper) return;

    var itemCode = wrapper.getAttribute('data-item-code');
    if (!itemCode) return;

    var card = wrapper.closest('.item-card, .card');
    if (!card) return;

    var input = wrapper.querySelector('.cart-qty');
    var current = parseInt(input && input.value ? input.value : '0', 10);
    if (isNaN(current) || current < 0) current = 0;

    var dir = upDownBtn.getAttribute('data-dir');
    if (dir === 'up') {
      var upVal = current + 1;
      if (input) input.value = String(upVal);
      updateQty(card, itemCode, upVal);
    } else if (dir === 'dwn') {
      var next = current - 1;
      if (next < 0) next = 0;
      if (input) input.value = String(next);
      updateQty(card, itemCode, next);
    }
  });

  // Handle manual quantity input (typing directly in the field)
  document.addEventListener('change', function (event) {
    if (window.webhqOwnedSurface && window.webhqOwnedSurface(event.target)) return;
    var input = event.target.closest('.listing-qty-wrapper .cart-qty');
    if (!input) return;

    var wrapper = input.closest('.listing-qty-wrapper');
    if (!wrapper) return;

    var itemCode = wrapper.getAttribute('data-item-code');
    if (!itemCode) return;

    var card = wrapper.closest('.item-card, .card');
    if (!card) return;

    var newQty = parseInt(input.value || '0', 10);
    if (isNaN(newQty) || newQty < 0) newQty = 0;

    updateQty(card, itemCode, newQty);
  });

  // Ensure manual edits are synced before navigating via the inline cart link.
  document.addEventListener('click', function (event) {
    if (window.webhqOwnedSurface && window.webhqOwnedSurface(event.target)) return;
    var cartLink = event.target.closest('.listing-go-to-cart');
    if (!cartLink) return;

    var wrapper = cartLink.closest('.listing-qty-wrapper');
    if (!wrapper) return;

    var input = wrapper.querySelector('.cart-qty');
    if (!input) return;

    var itemCode = wrapper.getAttribute('data-item-code');
    if (!itemCode) return;

    var card = wrapper.closest('.item-card, .card');
    if (!card) return;

    var newQty = parseInt(input.value || '0', 10);
    if (isNaN(newQty) || newQty < 0) newQty = 0;

    var syncedQty = parseInt(input.dataset.syncedQty || '', 10);
    var isPending = input.dataset.pendingUpdate === '1';
    var isDirty = isNaN(syncedQty) || syncedQty !== newQty;
    if (!isPending && !isDirty) return;

    event.preventDefault();

    if (cartLink.dataset.syncing === '1') return;
    cartLink.dataset.syncing = '1';

    updateQty(card, itemCode, newQty);
    setTimeout(function () {
      cartLink.dataset.syncing = '0';
      window.location.href = cartLink.getAttribute('href') || '/cart';
    }, 350);
  });
});
